'use client';

import { useEffect } from 'react';

export function TrustpilotScript() {
  useEffect(() => {
    const loadScript = () => {
      if (document.querySelector('script[src*="trustpilot"]')) return;
      const s = document.createElement('script');
      s.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
      s.async = true;
      document.body.appendChild(s);
    };

    if ('requestIdleCallback' in window) {
      (window as Window).requestIdleCallback(loadScript, { timeout: 4000 });
    } else {
      setTimeout(loadScript, 3000);
    }
  }, []);

  return null;
}
